var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M10.5 11.6951H7.601L7.602 11.6861C7.73257 11.0467 7.98813 10.4394 8.354 9.89905C8.89845 9.09687 9.66215 8.46821 10.554 8.08805C10.856 7.96005 11.171 7.86205 11.492 7.79705C12.1579 7.66205 12.8441 7.66205 13.51 7.79705C14.467 7.99315 15.3451 8.46647 16.035 9.15805L17.451 7.74605C16.8128 7.10769 16.0578 6.5981 15.227 6.24505C14.8033 6.06568 14.3628 5.92901 13.912 5.83705C12.9818 5.64807 12.0232 5.64807 11.093 5.83705C10.6419 5.92939 10.201 6.0664 9.777 6.24605C8.52753 6.77616 7.45793 7.65614 6.697 8.78005C6.18489 9.53791 5.82676 10.389 5.643 11.2851C5.615 11.4201 5.6 11.5581 5.58 11.6951H2.5L6.5 15.6951L10.5 11.6951ZM14.5 13.6951H17.399L17.398 13.7031C17.1367 14.9848 16.3812 16.1121 15.295 16.8411C14.7548 17.2072 14.1475 17.4628 13.508 17.5931C12.8424 17.7281 12.1566 17.7281 11.491 17.5931C10.8516 17.4625 10.2443 17.2069 9.704 16.8411C9.43862 16.6615 9.19085 16.4573 8.964 16.2311L7.55 17.6451C8.18851 18.2832 8.94392 18.7925 9.775 19.1451C10.199 19.3251 10.642 19.4621 11.09 19.5531C12.0198 19.7422 12.9782 19.7422 13.908 19.5531C15.7005 19.181 17.2773 18.1245 18.303 16.6081C18.8146 15.8508 19.1724 15.0003 19.356 14.1051C19.383 13.9701 19.399 13.8321 19.419 13.6951H22.5L18.5 9.69505L14.5 13.6951Z",
    fill: "#1B1A1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.196de154588bd285085aeafb28cbff57.svg";
export { ForwardRef as ReactComponent };